import { Box, Button, TextField } from "@mui/material";
import React from "react";
import { AdminListContext } from "../context/adminListContext";

const RenderTopBar = (): React.JSX.Element => {
  const {
    search,
    setSearch,
    setAddAdmin,
  }: {
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    setAddAdmin: React.Dispatch<React.SetStateAction<boolean>>;
  } = React.useContext(AdminListContext);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 2,
        width: "100%",
        mb: 3,
      }}
    >
      <TextField
        size="small"
        color="secondary"
        sx={{
          width: "300px",
        }}
        type="text"
        id="search-Admin"
        label="Admin suchen"
        variant="outlined"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
      <Button
        size="large"
        variant="contained"
        color="secondary"
        sx={{
          height: "40px",
        }}
        onClick={() => setAddAdmin(true)}
      >
        Admin hinzufügen
      </Button>
    </Box>
  );
};

export default RenderTopBar;
